import { Link } from "react-router-dom";
import { t } from "ttag";

import { MODAL_ROUTES, ROUTES, useNavigateModal } from "@/app/router";
import { usePortalUserStore } from "@/app/stores";
import { Button, CircleIcon, TestTubeIcon } from "@/shared/ui";
import { DocumentCard } from ".";

export const DocumentCenterLabs = () => {
  const navigateModal = useNavigateModal();

  const hasActiveSubscription = usePortalUserStore(
    (state) => state.hasActiveSubscription,
  );

  return (
    <DocumentCard.Root>
      <DocumentCard.Banner>
        <CircleIcon icon={TestTubeIcon} size="lg" />
      </DocumentCard.Banner>

      <DocumentCard.Content>
        <DocumentCard.Title>{t`Labs`}</DocumentCard.Title>
        <DocumentCard.Description>{t`View and manage your lab results and lab orders here.`}</DocumentCard.Description>
      </DocumentCard.Content>

      <DocumentCard.Actions>
        <Button asChild variant="secondary" size="lg">
          <Link to={ROUTES.DOCUMENT_CENTER.LABS}>{t`View details`}</Link>
        </Button>
        {hasActiveSubscription && (
          <Button
            onClick={() => navigateModal(MODAL_ROUTES.DOCUMENT_CENTER.LABS)}
            size="lg"
          >
            {t`Upload lab test`}
          </Button>
        )}
      </DocumentCard.Actions>
    </DocumentCard.Root>
  );
};
